import axios from 'axios';

export const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8001';

// Единая точка обработки истёкшего/невалидного токена — тот же приём, что в Refero
// (adminAuth.js): без него страницы молча повисают на "Загрузка..." при 401/403.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('astraToken');
      localStorage.removeItem('astraRole');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export function authHeaders() {
  const token = localStorage.getItem('astraToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Бэкенд иногда отдаёт структурированный detail — объект, не строку (см. auth.py,
// например sms_disabled/email_not_bound). setError(e.response?.data?.detail) на таком
// ответе роняет React с "Objects are not valid as a React child" (см.
// SECURITY_AUDIT_2026-09-18.md Q-20). В админку такие ответы сейчас не приходят, но
// это на будущее, если _assert_can_browse-стиль расползётся сюда.
export function errText(e, fallback = 'Что-то пошло не так') {
  const detail = e?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') return detail.message || fallback;
  return fallback;
}

export default axios;
